module.exports = __webpack_public_path__ + "static/media/UsersTemplate.619cade6.xlsx";